import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  BLOCKS,
  Document as ContentfulDocument,
  INLINES,
  Node,
} from "@contentful/rich-text-types";
import css from "./RichText.module.css";

import { FC, Fragment } from "react";
import Link from "next/link";
import { ContentImage } from "@/components/molecules/ContentImage/ContentImage";
import { AssetFields } from "contentful";
import { Gallery } from "@/components/molecules/Gallery/Gallery";
import { cn } from "@boostdev/design-system-components/utils";

interface IClassNames {
  [className: string]: string;
}

interface RichTextProps {
  body: ContentfulDocument;
  imgWidth?: number;
  customStyles?: IClassNames;
  classNames?: string;
}

const RichText: FC<RichTextProps> = ({ body, imgWidth, classNames }) => {
  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: H2,
      [BLOCKS.HEADING_3]: H3,
      [BLOCKS.HEADING_4]: H4,
      [BLOCKS.PARAGRAPH]: P,
      [BLOCKS.EMBEDDED_ENTRY]: EmbeddedEntryBlock,
      [BLOCKS.EMBEDDED_ASSET]: IMG,
      [INLINES.HYPERLINK]: A,
      [INLINES.ENTRY_HYPERLINK]: EntryLink,
      [INLINES.EMBEDDED_ENTRY]: EmbeddedEntryInline,
    },
  };

  function H2(node: Node, children: any) {
    return <h2>{children}</h2>;
  }
  function H3(node: Node, children: any) {
    return <h3>{children}</h3>;
  }
  function H4(node: Node, children: any) {
    return <h4>{children}</h4>;
  }
  function P(node: Node, children: any) {
    return <p>{children}</p>;
  }

  function EmbeddedEntryBlock(node: Node) {
    const fields = node.data.target.fields;
    return (
      <section className={css.articleSection}>
        {Object.entries(fields).map(([key, value]) => {
          if (key === "title")
            return <h2 key={key + value}>{value as string}</h2>;
          if (key === "gallery")
            return <Gallery key={key + value} media={value as any} />;
          if (key === "description")
            return <RichText key={key + value} body={value as any} />;
          return <Fragment key={key + value}></Fragment>;
        })}
      </section>
    );
  }

  function EmbeddedEntryInline(node: Node) {
    if (node.data.target.sys.contentType.id === "quote") {
      return <></>;
    }
    return <></>;
  }

  function A(node: Node, children: any) {
    return <Link href={node.data.uri}>{children}</Link>;
  }

  function EntryLink(node: Node) {
    console.log(node.data.target.sys);
    // return <Link href={node.data.uri}>{children}</Link>;
    return <></>;
  }

  function IMG(node: Node) {
    return (
      <ContentImage
        className={css.singleImage}
        fields={node.data.target.fields as AssetFields}
        width={imgWidth}
      />
    );
  }

  return (
    <article className={cn(css.richText, classNames)}>
      {documentToReactComponents(body, options)}
    </article>
  );
};
export default RichText;
